
const SET_LIST = (state, schedule) => {
  state.list = schedule
}

const SET_APPOINTMENTS = (state, payload) => {
  state.appointments = payload
}

const SET_AVAILABLEAPPOINTMENTS = (state, payload) => {
  state.commitments = payload
}

const SET_APPOINTMENTSSURGERYCENTER = (state, schedule) => {
  state.appointmentsSurgeryCenter = schedule
}

const SET_PROPOSEDSURGERIES = (state, payload) => {
  state.proposedSurgeries = payload
}

const SET_SURGERIES = (state, payload) => {
  state.surgeries = payload
}

const SET_ANESTHESIA = (state, payload) => {
  state.anesthesia = payload
}

export default {
  SET_LIST,
  SET_APPOINTMENTS,
  SET_AVAILABLEAPPOINTMENTS,
  SET_APPOINTMENTSSURGERYCENTER,
  SET_PROPOSEDSURGERIES,
  SET_SURGERIES,
  SET_ANESTHESIA
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/mutations.js